export const useCascadingFilters = ({ districts, locations, watch, setValue }) => {
  const [watchedDivisions, watchedDistricts] = watch(["divisions", "districts"]);

  const getFilteredDistricts = () => {
    let selectedDivisionIds = watchedDivisions.map((division) => division.id);
    return districts.filter((district) => selectedDivisionIds.includes(district.division_id));
  };

  const getFilteredLocations = () => {
    let selectedDistrictIds = watchedDistricts.map((district) => district.id);
    return locations.filter((location) => selectedDistrictIds.includes(location.district_id));
  };

  const filteredDistricts = getFilteredDistricts();
  const filteredLocations = getFilteredLocations();

  const updateLocations = (data) => {
    let selectedDistrictIds = data.map((district) => district.id);

    let filteredLocations = locations.filter((location) =>
      selectedDistrictIds.includes(location.district_id)
    );

    setValue("location_ids", filteredLocations, { shouldValidate: true });
  };

  const handleCascadingFilters = (data, onChange, type) => {
    onChange(data);

    if (type == "divisions") {
      let selectedDivisionIds = data.map((division) => division.id);
      let filteredDistricts = districts.filter((district) =>
        selectedDivisionIds.includes(district.division_id)
      );
      setValue("districts", filteredDistricts);

      updateLocations(filteredDistricts);
    } else if (type == "districts") {
      updateLocations(data);
    }
  };

  return { filteredDistricts, filteredLocations, handleCascadingFilters };
};
